import script from "./PreFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PreFooter.vue?vue&type=script&setup=true&lang=js"

import "./PreFooter.vue?vue&type=style&index=0&id=08d58895&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d58895"]])

export default __exports__